import { render, staticRenderFns } from "./addUpgrade.vue?vue&type=template&id=017c133d&scoped=true&"
import script from "./addUpgrade.vue?vue&type=script&lang=js&"
export * from "./addUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./addUpgrade.vue?vue&type=style&index=0&id=017c133d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c133d",
  null
  
)

component.options.__file = "addUpgrade.vue"
export default component.exports